// src/pages/Terms.jsx
import TermsContent from "./policies/TermsContent";

export default function Terms() {
  return (
    <div className="page">
      <div className="mx-auto max-w-3xl">
        <article className="card prose prose-invert">
          <TermsContent />
        </article>
      </div>
    </div>
  );
}
